import React, { Fragment, useEffect, useState } from 'react'
import { Container, Row, Col, Modal, Button } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '../../../context/auth/useAuth'
import { Link, useParams } from 'react-router-dom'
import { getOrdersClient, changeToDelivery, changeToDelivered } from '../../../actions/ordersActions'
import { CustomDataTable } from '../../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'

export default function UserOrders() { 
  	const { t } = useTranslation()
	const dispatch = useDispatch()
	const {client} = useAuth()
    const {id} = useParams()

	const {orders, resultorder} = useSelector(state=>state.orders)

    const [modalShow, setModalShow] = useState(false)
    const [orderToShow, setOrderToShow] = useState({})

	useEffect(() => {
		if(client){
			dispatch(getOrdersClient(id))
		}
	},[dispatch, t, client, id])

    const showOrder = (orderid) => {
		setOrderToShow(orders?.find(order => order._id === orderid))

		setModalShow(true)
    }

    const setOrderDelivered = async(e, idOrder) => {
        e.preventDefault()

		dispatch(changeToDelivered(idOrder, 'admin'))
	}

    const setOrderToDelivery = async(e, idOrder) => {
        e.preventDefault()

		dispatch(changeToDelivery(idOrder, 'admin'))
	}

    useEffect(() => {
        if(resultorder){
            switch (resultorder) {
                case 'changedsuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.orders.changedsuccess')
                    }).then(() => {
                        setModalShow(false)
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultorder])

	const columnsOrders = [
		{
			name: t('admin.orders.state'),
			cell: order =>
				<div>
					{order?.isDelivered
						?
							t('admin.orders.delivered')
						:
							t('admin.orders.fordelivery')
					}
				</div>,
			selector: (order) => order?.orderReference,
			sortable: true,
		},{
			name: t('admin.orders.reference'),
			cell: order =>
				<div>
					{order?.orderReference}
				</div>,
			selector: (order) => order?.orderReference,
			sortable: true,
		},{
			name: t('admin.orders.order'),
			cell: order =>
				<div>
					{order?.restaurant}
				</div>,
			selector: (order) => order?.restaurant,
			sortable: true,
		},{
			name: t('admin.orders.hour'),
			cell: order =>
				<div>
					{order?.hour}
				</div>,
			selector: (order) => order?.hour,
			sortable: true,
		},{
			name: t('admin.orders.client'),
			cell: order =>
				<div>
					{order?.user}
				</div>,
			selector: (order) => order?.user,
			sortable: true,
		},{
			name: t('admin.orders.dishes'),
			cell: order =>
				<div>
                    - {order?.firstdish?.name}<br/>
					- {order?.seconddish?.name}<br/>
					- {order?.drink?.name}<br/>
					- {order?.dessert?.name}<br/>
                    {order?.complements?.map((complement, index) =>(
                        <Fragment key={index}>- {complement?.name}<br/></Fragment>
                    ))}
				</div>,
			selector: (order) => order?.user?.name,
			sortable: false,
		},{
			name: '',
			cell: order =>
				<div>
					<label onClick={() => showOrder(order?._id)}>
						{t('admin.orders.details')}
					</label>
				</div>,
			sortable: false,
		}
	]

	return (
        <Container className='p-5'>
            <Row className="mb-3">
                <Col xs={2} className='p-0'>
                    <Link className="p-0 my-3" to="/admin/users">
                        <img src="../../images/arrow-back.svg" alt="arrow-back" width={25}></img>
                    </Link>
                </Col>
                <Col xs={8} className='text-center'>
                    <h1 className='fs-18'>{t('admin.orders.ordersdelivered')}</h1>
                </Col>
                <Col xs={2}></Col>
            </Row>
            <Row className="mt-5 ">
                <label className='sd-label-medium'>{t('admin.orders.listordersdelivered')}</label>
            </Row>
            <Row className="fullwidth">
                {orders?.length > 0
                    ?
                        <CustomDataTable columns={columnsOrders} data={orders} />
                    :
                        <h4 className='mt-4'>{t('admin.orders.thereisnotordersdelivered')}</h4>
                }
            </Row>
            <Modal show={modalShow} className="sd-modal" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">{t('admin.orders.order')} {orderToShow?.orderReference}</Modal.Title>
                    <i className='fa fa-times' onClick={() => setModalShow(false)}></i>
                </Modal.Header>
                <Modal.Body>
                    <div className="px-4 formulario">
						<Row className="text-start my-3">
							- {t('admin.orders.client')}: {orderToShow?.user}<br/>
							- {t('admin.orders.restaurant')}: {orderToShow?.restaurant}<br/>
							- {t('admin.orders.hour')}: {orderToShow?.hour+' ('+orderToShow?.date?.substr(8,2)+'/'+orderToShow?.orderAt?.substr(5,2)+'/'+orderToShow?.orderAt?.substr(0,4)+')'}<br/>
							- {t('admin.orders.orderat')}: {orderToShow?.orderAt?.substr(11,5)+' ('+orderToShow?.orderAt?.substr(8,2)+'/'+orderToShow?.orderAt?.substr(5,2)+'/'+orderToShow?.orderAt?.substr(0,4)+')'}<br/>
							- {t('admin.orders.firstdish')}: {orderToShow?.firstdish?.name}<br/>
							- {t('admin.orders.seconddish')}: {orderToShow?.seconddish?.name}<br/>
							- {t('admin.orders.drink')}: {orderToShow?.drink?.name}<br/>
							- {t('admin.orders.dessert')}: {orderToShow?.dessert?.name}<br/>
							{orderToShow?.complements?.length > 0
								?
									<Fragment>
										- {t('admin.orders.complements')}: 
										{orderToShow?.complements?.map((complement, index) =>(
											<Fragment key={index}>- {complement?.name}<br/></Fragment>
										))}
									</Fragment>
								:
									<></>
							}
						</Row>
						<Row className="text-start my-3">
						{orderToShow.isDelivered
							?
								<Button type="button" className="btn-primary my-2 w-100" onClick={(e) => setOrderToDelivery(e, orderToShow?._id)}>
									<label className='label-button'>{t('admin.orders.changetodelivery')}</label>
								</Button>
							:
								<Button type="button" className="btn-primary my-2 w-100" onClick={(e) => setOrderDelivered(e, orderToShow?._id)}>
									<label className='label-button'>{t('admin.orders.changetodelivery')}</label>
								</Button>
						}
						</Row>
					</div>
                </Modal.Body>
            </Modal>
        </Container>
	)
}